import { IonCol, IonRow, IonText } from "@ionic/react";
import { Pole_t } from "../../types/pole";

interface Props {
  href: string;
  pole: Pole_t;
  arrayLength: number;
  size: number;
}

const Pole: React.FC<Props> = ({ href, pole, arrayLength, size }) => {

  return (
    <IonCol
      size-lg={(size / arrayLength) * 12}
      size={((size / arrayLength) * 12).toString()}
      size-sm={(size / arrayLength) * 12}
      className="ion-justify-content-center"
    >
      <IonRow className="ion-justify-content-center">
        <IonCol
          onClick={() => {
            if ((pole as any).disabled) return;
            if (typeof pole.value === "number") {
              localStorage.setItem("pole", pole.value.toString());
              window.location.href = href;
            } else window.location.href = href + pole.value;
          }}
          className="btn fullWidth no-margin"
          size-sm="11"
          size="11"
          size-lg="11"
          style={{
            background: (pole as any).disabled ? "gray" : "",
            cursor: (pole as any).disabled ? "not-allowed" : "",
          }}
        >
          <IonText>
            <h3 className="no-padding no-margin">{pole.name}</h3>
          </IonText>
        </IonCol>
      </IonRow>
    </IonCol>
  );
};

export default Pole;
